import {
  Avatar,
  Box,
  Button,
  Card,
  CardActionArea,
  CardContent,
  CardHeader,
  styled,
} from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import ContentCopyOutlinedIcon from "@mui/icons-material/ContentCopyOutlined";
import { SearchBar } from "@components/Search";

export const ShareLinkIcon = styled(ContentCopyOutlinedIcon)(({ theme }) => ({
  width: "24px",
  height: "24px",
  marginRight: "8px",
  color: theme.palette.text.black,
}));

export const RequestsListContainer = styled("div")`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 16px;
  padding-bottom: 8px;
  width: 100%;
`;

export const RequestContainer = styled("div")({
  display: "flex",
  flexDirection: "column",
  flex: 1,
  gap: "16px",
  maxWidth: 800,
  width: "100%",
});

export const PatientContainer = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "16px",
  maxWidth: 360,
  width: "100%",
}));

export const EmptyRequest = styled("p")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: "8px",
  padding: "72px 0px",
  color: theme.palette.text.gray,
}));

export const StyledInfoIcon = styled(InfoOutlinedIcon)(() => ({
  fontSize: "24px",
}));

export const WhiteBackgroundBody = styled(Box)(({ theme }) => ({
  padding: "0px 16px",
  width: "100%",
  backgroundColor: theme.palette.background.white,
  borderRadius: 6,
}));

export const Search = styled(SearchBar)({
  position: "static",
  maxWidth: "100%",
});

export const HomeInteractionsContainer = styled(Box)({
  display: "flex",
  gap: "16px",
  padding: "16px 0px",
});

export const InteractionTextContainer = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  textAlign: "center",
  fontWeight: 500,
});

export const StyledShareIcon = styled(ContentCopyOutlinedIcon)(() => ({
  color: "white",
}));

export const Row = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  width: "100%",
  gap: "16px",
});

export const PatientsListCard = styled(Card)(({ theme }) => ({
  borderRadius: "8px",
  backgroundColor: theme.palette.background.white,
  width: 360,
}));

export const PatientsListCardHeader = styled(CardHeader)(() => ({
  width: "100%",
  paddingTop: "24px",
  paddingBottom: "12px",
}));

export const PatientsListCardContent = styled(CardContent)(() => ({
  display: "flex",
  flexDirection: "column",
  paddingTop: "12px",
  gap: "24px",
}));

export const PatientListItem = styled(CardActionArea)(() => ({
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "center",
  alignSelf: "stretch",
  gap: "12px",
  //TODO: Change to theme.palette.divider
  borderBottom: "1px solid #EAEAEA",
}));

export const PatientListItemContent = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
  padding: "16px",
  alignItems: "baseline",
}));

export const StyledAvatar = styled(Avatar)(({ theme }) => ({
  backgroundColor: theme.palette.primary.extraLight,
}));

export const AddPatientButton = styled(Button)(({ theme }) => ({
  borderRadius: 20.5,
  border: `1px solid ${theme.palette.primary.dark}`,
  backgroundColor: theme.palette.primary.extraLight,
  color: theme.palette.primary.dark,
  textTransform: "none",
}));
